<template>
<div class="step-info-container">
  <p>{{ $t('step_nav.step') }} {{ step }}/{{ totalSteps }}: {{ message }}</p>
</div>
</template>

<script>
export default {
  name: 'step_info',
  props: {
    step: String,
    totalSteps: String,
    message: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-down-breakpoint: 1199px;
    $tablet-breakpoint: 1200px;
    $hd-desktop-breakpoint: 1280px;

    .step-info-container {
      display: flex;
      flex: 1 0 100%;
      justify-content: center;
      width: 100%;

      p {
        background-color: #fff;
        flex: 0 0 auto;
        font-size: 1rem;
        font-family: 'FuturaPTMedium';
        margin: 40px 0;
        padding: 15px 65.5px;
      }

      @media screen and (min-width: $tablet-breakpoint) and (max-width: $hd-desktop-breakpoint) {
        p {
          margin: 21px 0;
          padding: 9.5px 65.5px;
        }
      }
      @media screen and (max-width: $tablet-portrait-down-breakpoint) {
        p {
          margin: 21px 0;
          padding: 15px;
        }
      }
    }
  }
</style>